import { openModal } from '@core/components/ModalStack';
import { ViewLabourTypeModalProps } from './ViewLabourTypeModal';

export async function openViewLabourTypeModal(props: ViewLabourTypeModalProps) {
  const { ViewLabourTypeModal } = await import('./ViewLabourTypeModal');

  openModal(ViewLabourTypeModal, props);
}
